export default function WalletLedgerNotice({ visible }) {
  if (!visible) return null
  return <p role="status" style={{ background: '#fff3cd', color: '#664d03', padding: '12px', borderRadius: '4px' }}>
    Flutterwave data temporarily unavailable—showing saved records. Refresh the filter to retry live data.
  </p>
}
